import $ from 'jquery';

// Account pages js
export default class Account {
  constructor() {

    // Deal with showing / hiding elements on login page
    const $formWrapper = $('[data-login-forms]');

    if ($formWrapper.length) {
      $formWrapper.on('click', '[data-toggle-account-recovery]', () => {
        $formWrapper.toggleClass('show-account-recovery');
      });

      if ($('.account-recovery').find('.errors').length > 0) {
        $formWrapper.toggleClass('show-account-recovery');
      }
    }

    this.$customerAddresses = $('[data-address-id]');
    if (this.$customerAddresses) { this.addressPage(); }
  }

  addressPage() {
    const $addressEditLinks = $('[data-edit-address]');

    if ($addressEditLinks.length) {
      $addressEditLinks.on('click', (event) => {
        const itemId = $(event.target).attr('data-edit-address');
        $('[data-address-id]').removeClass('account-address-form-active');
        $(`[data-address-id="${itemId}"]`).addClass('account-address-form-active');
      });
    }

    const $addressDeleteLinks = $('[data-delete-address]');

    if ($addressDeleteLinks.length) {
      $addressDeleteLinks.on('click', (event) => {
        const itemId = $(event.target).attr('data-delete-address');
        Shopify.CustomerAddress.destroy(itemId);
      });
    }

    this.$customerAddresses.each(function () {
      const id = $(this).attr('data-address-id');

      // Initiate provinces for the New Address form
      new Shopify.CountryProvinceSelector(
        `customer-addr-${id}-country`,
        `customer-addr-${id}-province`,
        {hideElement: `address-province-container-${id}`}
      );
    });
  }
}
